_collow.components.Popup = class Popup extends _collow.components.Base {
  root;
  elements;
  params;
  registrationId;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(document, "_collow.popup", this.popupHandler);

    this.listen(
      document.body,
      ["_collow.open-popup", "_collow.close-popup", "_collow.open.message"],
      ({ detail }) =>
        this.root[detail.type == "open" ? "removeAttribute" : "setAttribute"](
          "hidden",
          ""
        )
    );
  }

  /**
   * @param {*} param0
   * triggered on custom event and show's the popup box
   */
  popupHandler = ({ detail }) => {
    this.elements[
      detail.error == "name" ? "nameMessage" : "generalMessage"
    ].removeAttribute("hidden", "");
    detail.error; // nameMessage generalMessage
    // make the page unscrollable or scrolable based on input
    document.documentElement[
      detail.type == "open" ? "setAttribute" : "removeAttribute"
    ]("data-backdrop", "");
    this.root[detail.type == "open" ? "removeAttribute" : "setAttribute"](
      "hidden",
      ""
    );
    // listen or unlisten to events to close/open popup
    ["_collow.overlay.clicked", "_collow.escape.keydown"].forEach((event) =>
      this[detail.type == "open" ? "listen" : "unlisten"](
        document,
        event,
        this.closePopup
      )
    );
    // listen/unlisten for button clicks close
    this[detail.type == "open" ? "listen" : "unlisten"](
      this.elements.close,
      "click",
      this.closePopup
    );
  };

  closePopup = () => {
    this.root.setAttribute("hidden", "");
    [this.elements.nameMessage, this.elements.generalMessage].forEach((el) =>
      el.setAttribute("hidden", "")
    );
    this.dispatch(this.root, "_collow.popup", { type: "close" });
  };
};
